import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  generateVisit,
  getProfileVisualizer,
  getProfileData,
} from "../../store/actions";
import PerfilMain from "../../components/Perfil/PerfilMain/PerfilMain";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import RegisteredUserProfileLoader from "./RegisteredUsersSkeleton/RegisteredUserProfileLoader";
import BotoneraModern from "../../components/Botonera/BotoneraModern.tsx";
import useNavVisibility from "../../hooks/useNavVisibility.ts";
import { fireAnalytics } from "../../utils/firebase";
import { getSessionId, getDeviceCategory, getPreviousPage } from "../../utils/analyticsHelpers.ts";

const Container = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    height: 100%;

`;

const RegisteredUserProfile = ({
  generateVisit,
  getProfileVisualizer,
  profileVisualizerData,
  getProfileData,
  loading,
  userData,
  ...props }) => {
  const { ocultarEnMobile, mobileStylesFromParent } = useNavVisibility();
  const { id } = useParams();

  const userId = id === userData.id ? userData.id : id;

  const myPerson = userId === userData.id


  //Genera la visita en el perfil
  useEffect(() => {
    if (!myPerson) {
      generateVisit(parseInt(userId));
      
      // Evento de analytics para visita de perfil
      fireAnalytics("profile_view", {
        edify_user_id: userData?.id || "",
        session_id: getSessionId(),
        source: getPreviousPage() ? "navigation" : "direct",
        previous_page: getPreviousPage(),
        device_category: getDeviceCategory(),
        category: "profile",
        action: "profile_view",
        visited_user_id: userId || "",
        is_own_profile: false
      });
    } else {
      // Evento de analytics para visita al propio perfil
      fireAnalytics("profile_view", {
        edify_user_id: userData?.id || "",
        session_id: getSessionId(),
        source: getPreviousPage() ? "navigation" : "direct",
        previous_page: getPreviousPage(),
        device_category: getDeviceCategory(),
        category: "profile",
        action: "profile_view",
        visited_user_id: userId || "",
        is_own_profile: true
      });
    }
  }, [userId, userData]);

  useEffect(() => {
    if (!myPerson) {
      getProfileVisualizer(userId);
    } else {
      getProfileData(userId);
    }
  }, [userId]);


  return (
    <Container>
      {ocultarEnMobile ? <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} /> : null}
      {loading ? <RegisteredUserProfileLoader /> :
        <PerfilMain
          perfilAjeno={userId}
          profileVisualizerData={profileVisualizerData}
          myPerson={myPerson} />
      }
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.general.userData,
    profileVisualizerData: state.general.profileVisualizer,
    loading: state.general.componentLoading,
  };
};

export default connect(mapStateToProps, {
  generateVisit,
  getProfileVisualizer,
  getProfileData,
})(RegisteredUserProfile);
